module.exports = __webpack_public_path__ + "img/02.f21324db.jpg";